import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=24077968&scoped=true&"
import script from "./draw.vue?vue&type=script&lang=js&"
export * from "./draw.vue?vue&type=script&lang=js&"
import style0 from "./draw.vue?vue&type=style&index=0&id=24077968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24077968",
  null
  
)

export default component.exports